import {
  openBlock as e,
  createBlock as t,
  defineComponent as a,
  computed as l,
  mergeProps as n,
  renderSlot as o,
  createVNode as r,
  toDisplayString as s,
  createCommentVNode as i,
  ref as d,
  Fragment as u,
  renderList as c,
  resolveComponent as m,
  withCtx as g,
  pushScopeId as b,
  popScopeId as p,
  withScopeId as I,
  withModifiers as f,
  createTextVNode as v,
} from 'vue'

const x = {}
x.render = function (a, l) {
  return e(), t('div', null, ' TODO SIcon ')
}
const y =
    'px-4 py-2 border shadow-sm rounded-md focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 border-transparent text-white ',
  S = {
    bare: '',
    default: y + 'border-gray-300 text-gray-700 bg-white hover:bg-gray-50 ',
    primary: y + 'bg-indigo-600 hover:bg-indigo-700',
    secondary: y + 'bg-blue-500 hover:bg-blue-600',
    success: y + 'bg-green-400 hover:bg-green-500',
    danger: y + 'bg-red-500 hover:bg-red-600',
    warning: y + 'bg-yellow-500 hover:bg-yellow-600',
    'primary-o': y + 'text-indigo-600 border-indigo-600 hover:bg-indigo-100',
    'secondary-o': y + 'text-blue-500 border-blue-500 hover:bg-blue-100',
    'success-o': y + 'text-green-400 border-green-400 hover:bg-green-100',
    'danger-o': y + 'text-red-500 border-red-500 hover:bg-red-100',
    'warning-o': y + 'text-yellow-500 border-yellow-500 hover:bg-yellow-100',
  }
var w = a({
  name: 'SButton',
  props: {
    variant: {
      type: String,
      required: !1,
      default: 'default',
      validator: (e) => Object.keys(S).includes(e),
    },
  },
  setup: (e) => ({ classes: l(() => S[e.variant]) }),
})
w.render = function (a, l, r, s, i, d) {
  return (
    e(),
    t('button', n(a.$attrs, { class: a.classes }), [o(a.$slots, 'default')], 16)
  )
}
const h = {
  default:
    'h-4 w-4 text-red-600 focus:ring-red-500 border-red-300 rounded cursor-pointer',
}
var C = a({
  name: 'SCheckbox',
  inheritAttrs: !1,
  props: {
    variant: {
      type: String,
      required: !1,
      default: 'default',
      validator: (e) => Object.keys(h).includes(e),
    },
    label: { type: String, default: '' },
    modelValue: { type: Boolean, default: !1 },
  },
  emits: ['update:modelValue'],
  setup: (e, { attrs: t, emit: a }) => ({
    id:
      t.id ||
      'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (e) {
        const t = (16 * Math.random()) | 0
        return ('x' == e ? t : (3 & t) | 8).toString(16)
      }),
    classes: l(() => h[e.variant]),
    handleChange: (e) => {
      a('update:modelValue', e.target.checked)
    },
  }),
})
const A = { class: 'flex items-center' }
C.render = function (a, l, d, u, c, m) {
  return (
    e(),
    t('div', A, [
      r(
        'input',
        n(a.$attrs, {
          id: a.id,
          type: 'checkbox',
          class: a.classes,
          checked: a.modelValue,
          onChange:
            l[1] || (l[1] = (...e) => a.handleChange && a.handleChange(...e)),
        }),
        null,
        16,
        ['id', 'checked']
      ),
      o(a.$slots, 'label', {}, () => [
        a.label
          ? (e(),
            t(
              'label',
              {
                key: 0,
                for: a.id,
                class: 'cursor-pointer ml-2',
              },
              s(a.label),
              9,
              ['for']
            ))
          : i('', !0),
      ]),
      o(a.$slots, 'default'),
    ])
  )
}
const N = { default: 'block font-medium text-sm text-gray-600' }
var D = a({
  name: 'SLabel',
  props: {
    variant: {
      type: String,
      required: !1,
      default: 'default',
      validator: (e) => Object.keys(N).includes(e),
    },
  },
  setup: (e) => ({ classes: l(() => N[e.variant]) }),
})
D.render = function (a, l, r, s, i, d) {
  return (
    e(),
    t('label', n(a.$attrs, { class: a.classes }), [o(a.$slots, 'default')], 16)
  )
}
const j = 'w-full appearance-none block px-3 py-2 border rounded-md shadow-sm',
  k = {
    default: j + 'border-gray-300 placeholder-gray-400 focus:outline-none',
    withError: j + 'border-red-300 placeholder-red-400 ',
  }
var M = a({
  name: 'SInput',
  props: {
    variant: {
      type: String,
      required: !1,
      default: 'default',
      validator: (e) => Object.keys(k).includes(e),
    },
    modelValue: { type: String, default: null },
  },
  emits: ['update:modelValue'],
  setup: (e, { emit: t }) => ({
    classes: l(() => k[e.variant]),
    handleInput: (e) => {
      t('update:modelValue', e.target.value)
    },
  }),
})
M.render = function (a, l, o, r, s, i) {
  return (
    e(),
    t(
      'input',
      n(a.$attrs, {
        id: a.$attrs.id || a.$attrs.name,
        class: a.classes,
        type: a.$attrs.type || 'text',
        value: a.modelValue,
        onInput:
          l[1] || (l[1] = (...e) => a.handleInput && a.handleInput(...e)),
      }),
      null,
      16,
      ['id', 'type', 'value']
    )
  )
}
const V = {
  bare: '',
  default: 'font-medium text-indigo-600 hover:text-indigo-500',
  menu: 'text-sm text-gray-600 hover:text-green-700',
}
var B = a({
  name: 'SLink',
  props: {
    variant: {
      type: String,
      required: !1,
      default: 'default',
      validator: (e) => Object.keys(V).includes(e),
    },
  },
  setup: (e) => ({ classes: l(() => V[e.variant]) }),
})
B.render = function (a, l, r, s, i, d) {
  return (
    e(), t('a', n(a.$attrs, { class: a.classes }), [o(a.$slots, 'default')], 16)
  )
}
const G = a({
    name: 'DropdownButton',
    data: () => ({
      items: [
        {
          id: 1,
          icon: 'https://placehold.it/15x15',
          title: 'My account',
          link: '#',
        },
      ],
    }),
    setup(e, { attrs: t }) {
      const a = d(t.isOpen)
      return {
        isDropdownOpen: l(() => a.value),
        toggleDropdown: () => {
          a.value = !a.value
        },
      }
    },
  }),
  P = { class: 'flex justify-start cursor-pointer items-center' },
  H = { key: 0 },
  z = r(
    'img',
    {
      src:
        'data:image/svg+xml;base64,PHN2Zw0KICB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciDQogIGNsYXNzPSJpY29uIGljb24tdGFibGVyIGljb24tdGFibGVyLWNoZXZyb24tZG93biINCiAgd2lkdGg9IjIwIg0KICBoZWlnaHQ9IjIwIg0KICB2aWV3Qm94PSIwIDAgMjQgMjQiDQogIHN0cm9rZS13aWR0aD0iMS41Ig0KICBzdHJva2U9IiMyYzNlNTAiDQogIGZpbGw9Im5vbmUiDQogIHN0cm9rZS1saW5lY2FwPSJyb3VuZCINCiAgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCINCj4NCiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPg0KICA8cG9seWxpbmUgcG9pbnRzPSI2IDkgMTIgMTUgMTggOSIgLz4NCjwvc3ZnPg==',
    },
    null,
    -1
  ),
  Z = { key: 1 },
  $ = r(
    'img',
    {
      src:
        'data:image/svg+xml;base64,PHN2Zw0KICB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciDQogIGNsYXNzPSJpY29uIGljb24tdGFibGVyIGljb24tdGFibGVyLWNoZXZyb24tdXAiDQogIHdpZHRoPSIyMCINCiAgaGVpZ2h0PSIyMCINCiAgdmlld0JveD0iMCAwIDI0IDI0Ig0KICBzdHJva2Utd2lkdGg9IjEuNSINCiAgc3Ryb2tlPSIjMmMzZTUwIg0KICBmaWxsPSJub25lIg0KICBzdHJva2UtbGluZWNhcD0icm91bmQiDQogIHN0cm9rZS1saW5lam9pbj0icm91bmQiDQo+DQogIDxwYXRoIHN0cm9rZT0ibm9uZSIgZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIgLz4NCiAgPHBvbHlsaW5lIHBvaW50cz0iNiAxNSAxMiA5IDE4IDE1IiAvPg0KPC9zdmc+',
    },
    null,
    -1
  )
G.render = function (a, l, s, i, d, m) {
  return (
    e(),
    t(
      'div',
      n(a.$attrs, {
        class: 'flex items-center relative cursor-pointer h-full',
        onClick:
          l[1] || (l[1] = (...e) => a.toggleDropdown && a.toggleDropdown(...e)),
      }),
      [
        r('div', null, [
          r(
            'ul',
            {
              class: [
                { hidden: !a.isDropdownOpen },
                'p-2 w-40 border-r bg-white absolute rounded left-0 shadow mt-8',
              ],
            },
            [
              (e(!0),
              t(
                u,
                null,
                c(
                  a.items,
                  (l) => (
                    e(),
                    t('li', P, [o(a.$slots, 'dropdownContent', { content: l })])
                  )
                ),
                256
              )),
            ],
            2
          ),
        ]),
        o(a.$slots, 'button'),
        o(
          a.$slots,
          'controlButton',
          { isDropdownOpen: a.isDropdownOpen },
          () => [
            a.isDropdownOpen
              ? (e(), t('div', Z, [$]))
              : (e(), t('div', H, [z])),
          ]
        ),
      ],
      16
    )
  )
}
var L = a({
  name: 'SFormField',
  components: { SLabel: D },
  props: {
    label: { type: String, default: '' },
    name: { type: String, default: '' },
    horizontal: { type: Boolean, default: !1 },
  },
})
L.render = function (a, l, d, u, c, b) {
  const p = m('SLabel')
  return (
    e(),
    t(
      'div',
      n(a.$attrs, {
        class: {
          'grid grid-cols-2 gap-4 sm:gap-2 items-center first:border-t border-b border-gray-200 pt-5 pb-5':
            a.horizontal,
          'mb-5': !a.horizontal,
        },
      }),
      [
        o(a.$slots, 'before'),
        o(a.$slots, 'label', {}, () => [
          a.label
            ? (e(),
              t(
                p,
                {
                  key: 0,
                  for: a.name,
                  class: { 'mb-2': !a.horizontal },
                },
                {
                  default: g(() => [r('span', null, s(a.label), 1)]),
                  _: 1,
                },
                8,
                ['for', 'class']
              ))
            : i('', !0),
        ]),
        r('div', null, [o(a.$slots, 'default')]),
      ],
      16
    )
  )
}
const W = {}
W.render = function (a, l) {
  return e(), t('div', null, 'TODO SPackageCard')
}
var Q = a({ name: 'SSearchbar' })
const O = { class: 'relative w-full' },
  F = r(
    'div',
    { class: 'text-gray-500 absolute ml-4 inset-0 m-auto w-4 h-4' },
    [
      r('img', {
        src:
          'data:image/svg+xml;base64,PHN2Zw0KICAgICAgICB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciDQogICAgICAgIGNsYXNzPSJpY29uIGljb24tdGFibGVyIGljb24tdGFibGVyLXNlYXJjaCINCiAgICAgICAgd2lkdGg9IjE2Ig0KICAgICAgICBoZWlnaHQ9IjE2Ig0KICAgICAgICB2aWV3Qm94PSIwIDAgMjQgMjQiDQogICAgICAgIHN0cm9rZS13aWR0aD0iMS41Ig0KICAgICAgICBzdHJva2U9ImN1cnJlbnRDb2xvciINCiAgICAgICAgZmlsbD0ibm9uZSINCiAgICAgICAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIg0KICAgICAgICBzdHJva2UtbGluZWpvaW49InJvdW5kIg0KICAgICAgPg0KICAgICAgICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIC8+DQogICAgICAgIDxjaXJjbGUgY3g9IjEwIiBjeT0iMTAiIHI9IjciIC8+DQogICAgICAgIDxsaW5lIHgxPSIyMSIgeTE9IjIxIiB4Mj0iMTUiIHkyPSIxNSIgLz4NCiAgICAgIDwvc3ZnPg==',
      }),
    ],
    -1
  ),
  J = r(
    'input',
    {
      class:
        'border border-gray-100 focus:outline-none focus:border-indigo-700 rounded w-full text-sm text-gray-500 bg-gray-100 pl-12 py-2',
      type: 'text',
      placeholder: 'Search',
    },
    null,
    -1
  )
Q.render = function (a, l, n, o, r, s) {
  return e(), t('div', O, [F, J])
}
var U = { name: 'SHeader' }
const K = I('data-v-1944764e')
b('data-v-1944764e')
const R = { class: 'mx-auto' }
p()
const T = K((a, l, n, o, r, s) => (e(), t('div', R, 'TODO SHeader')))
;(U.render = T), (U.__scopeId = 'data-v-1944764e')
var _ = a({
  name: 'SLogin',
  components: { SFormField: L, SInput: M, SCheckbox: C, SButton: w, SLink: B },
  setup: () => ({}),
})
const Y = { class: 'mt-8 sm:mx-auto sm:w-full sm:max-w-md' },
  E = { class: 'flex flex-col md:flex-row mb-5 justify-between' },
  X = { class: 'flex-grow md:flex-initial md:ml-5' },
  q = v('Sign In'),
  ee = { class: 'text-center md:text-left' },
  te = v(' No account? '),
  ae = v('Sign up')
_.render = function (a, l, o, s, i, d) {
  const u = m('SInput'),
    c = m('SFormField'),
    b = m('SCheckbox'),
    p = m('SButton'),
    I = m('SLink')
  return (
    e(),
    t('div', Y, [
      r(
        'form',
        n(a.$attrs, { onSubmit: l[1] || (l[1] = f(() => !1, ['prevent'])) }),
        [
          r(
            c,
            {
              name: 'email',
              label: 'E-mail',
            },
            {
              default: g(() => [
                r(u, {
                  id: 'email',
                  name: 'email',
                  placeholder: 'accountname@rb2.nl',
                  class: 'w-full',
                  type: 'email',
                }),
              ]),
              _: 1,
            }
          ),
          r(
            c,
            { name: 'password', label: 'Password' },
            {
              default: g(() => [
                r(u, {
                  id: 'password',
                  name: 'password',
                  placeholder: 'password',
                  class: 'w-full',
                  type: 'password',
                }),
              ]),
              _: 1,
            }
          ),
          r('div', E, [
            r(b, {
              id: 'rememberme',
              name: 'rememberme',
              label: 'Keep me logged in',
            }),
            r('div', X, [
              r(
                p,
                {
                  variant: 'primary',
                  class: 'w-full justify-center py-2 px-4 right',
                },
                { default: g(() => [q]), _: 1 }
              ),
            ]),
          ]),
          r('div', ee, [
            te,
            r(
              I,
              { href: '#' },
              {
                default: g(() => [ae]),
                _: 1,
              }
            ),
          ]),
        ],
        16
      ),
    ])
  )
}
const le = a({
    name: 'SNavbar',
    components: { SLink: B, SSearchbar: Q, SDropdownButton: G },
    emits: ['toggleMobileNav'],
  }),
  ne = { class: 'hidden lg:flex w-full pr-6' },
  oe = {
    class:
      'text-gray-600 flex items-center relative w-full h-full visible flex lg:hidden relative',
  },
  re = r(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      class: 'icon icon-tabler icon-tabler-menu-2',
      width: '32',
      height: '32',
      viewBox: '0 0 24 24',
      'stroke-width': '1.5',
      stroke: '#2c3e50',
      fill: 'none',
      'stroke-linecap': 'round',
      'stroke-linejoin': 'round',
    },
    [
      r('path', { stroke: 'none', d: 'M0 0h24v24H0z', fill: 'none' }),
      r('line', {
        x1: '4',
        y1: '6',
        x2: '20',
        y2: '6',
      }),
      r('line', { x1: '4', y1: '12', x2: '20', y2: '12' }),
      r('line', { x1: '4', y1: '18', x2: '20', y2: '18' }),
    ],
    -1
  ),
  se = { class: 'w-2/4 p-1 lg:p-32 md:p-20' }
le.render = function (a, l, s, i, d, u) {
  return (
    e(),
    t(
      'nav',
      n(a.$attrs, {
        class:
          'h-16 flex items-center lg:items-stretch justify-end lg:justify-between bg-white shadow relative z-10',
      }),
      [
        r('div', ne, [o(a.$slots, 'content')]),
        r('div', oe, [
          o(a.$slots, 'mobileContent', {}, () => [
            r(
              'div',
              {
                class: 'w-1/4 pl-2 cursor-pointer h-full flex items-center',
                onClick: l[1] || (l[1] = (e) => a.$emit('toggleMobileNav')),
              },
              [re]
            ),
            r('div', se, [o(a.$slots, 'mobileBranding')]),
          ]),
        ]),
      ],
      16
    )
  )
}
var ie = a({
  name: 'SRegistration',
  components: { SFormField: L, SInput: M, SCheckbox: C, SButton: w, SLink: B },
  setup: () => ({
    email: d(''),
    password: d(''),
    confirmPassword: d(''),
    firstName: d(''),
    lastName: d(''),
    isAgree: d(!1),
    onSubmit: () => {
      console.log('Todo')
    },
  }),
})
const de = v(' Create your account '),
  ue = v(' or Log In To Your Account ')
ie.render = function (a, l, o, s, i, d) {
  const u = m('SInput'),
    c = m('SFormField'),
    b = m('SCheckbox'),
    p = m('SButton'),
    I = m('SLink')
  return (
    e(),
    t(
      'form',
      n({ class: 'sm:max-w-md' }, a.$attrs, {
        onSubmit:
          l[7] ||
          (l[7] = f((...e) => a.onSubmit && a.onSubmit(...e), ['prevent'])),
      }),
      [
        r(
          c,
          {
            name: 'email',
            label: 'E-mail address',
          },
          {
            default: g(() => [
              r(
                u,
                {
                  modelValue: a.email,
                  'onUpdate:modelValue': l[1] || (l[1] = (e) => (a.email = e)),
                  name: 'email',
                  type: 'email',
                },
                null,
                8,
                ['modelValue']
              ),
            ]),
            _: 1,
          }
        ),
        r(
          c,
          { name: 'password', label: 'Password' },
          {
            default: g(() => [
              r(
                u,
                {
                  modelValue: a.password,
                  'onUpdate:modelValue':
                    l[2] || (l[2] = (e) => (a.password = e)),
                  name: 'password',
                  type: 'password',
                },
                null,
                8,
                ['modelValue']
              ),
            ]),
            _: 1,
          }
        ),
        r(
          c,
          {
            name: 'confirm-password',
            label: 'Confirm password',
          },
          {
            default: g(() => [
              r(
                u,
                {
                  modelValue: a.confirmPassword,
                  'onUpdate:modelValue':
                    l[3] || (l[3] = (e) => (a.confirmPassword = e)),
                  name: 'confirm-password',
                  type: 'password',
                },
                null,
                8,
                ['modelValue']
              ),
            ]),
            _: 1,
          }
        ),
        r(
          c,
          { name: 'first-name', label: 'First name' },
          {
            default: g(() => [
              r(
                u,
                {
                  modelValue: a.firstName,
                  'onUpdate:modelValue':
                    l[4] || (l[4] = (e) => (a.firstName = e)),
                  name: 'first-name',
                },
                null,
                8,
                ['modelValue']
              ),
            ]),
            _: 1,
          }
        ),
        r(
          c,
          { name: 'last-name', label: 'Last name' },
          {
            default: g(() => [
              r(
                u,
                {
                  modelValue: a.lastName,
                  'onUpdate:modelValue':
                    l[5] || (l[5] = (e) => (a.lastName = e)),
                  name: 'last-name',
                },
                null,
                8,
                ['modelValue']
              ),
            ]),
            _: 1,
          }
        ),
        r(c, null, {
          default: g(() => [
            r(
              b,
              {
                id: 'terms',
                modelValue: a.isAgree,
                'onUpdate:modelValue': l[6] || (l[6] = (e) => (a.isAgree = e)),
                label: 'I accept the agreement of create an account',
              },
              null,
              8,
              ['modelValue']
            ),
          ]),
          _: 1,
        }),
        r(
          p,
          { type: 'submit', variant: 'primary', class: 'w-full mb-5' },
          {
            default: g(() => [de]),
            _: 1,
          }
        ),
        r(
          I,
          {
            href: '/?path=/story/components-organisms-login--default',
            class: 'flex justify-center',
          },
          { default: g(() => [ue]), _: 1 }
        ),
      ],
      16
    )
  )
}
const ce = a({
    name: 'SSidebar',
    inheritAttrs: !1,
    props: { isOpen: { type: Boolean, default: !1 } },
  }),
  me = {
    class:
      'w-64 absolute lg:relative bg-white shadow flex-col justify-between hidden lg:flex pb-12',
  },
  ge = { class: 'px-8' },
  be = { class: 'px-8' }
ce.render = function (a, l, n, s, i, d) {
  return (
    e(),
    t(
      u,
      null,
      [
        r('div', me, [r('div', ge, [o(a.$slots, 'content')])]),
        r(
          'div',
          {
            class: [
              a.isOpen ? '-translate-x-0' : '-translate-x-full',
              'absolute z-40 w-full h-full lg:hidden transform transition duration-150 ease-in-out',
            ],
            id: 'mobile-nav-bg',
          },
          [
            r(
              'div',
              {
                class: [
                  a.isOpen ? 'opacity-60' : 'opacity-0',
                  'bg-gray-800 transform w-full h-full absolute transition-opacity duration-150 ease-in-out',
                ],
                onClick: l[1] || (l[1] = (e) => a.$emit('toggleMobileNav')),
              },
              null,
              2
            ),
            r(
              'div',
              {
                class: [
                  a.isOpen ? '-translate-x-0' : '-translate-x-full',
                  'w-64 z-20 absolute bg-white shadow h-full flex-col justify-between pb4 transition duration-150 ease-in-out',
                ],
                id: 'mobile-nav',
              },
              [r('div', be, [o(a.$slots, 'mobileContent')])],
              2
            ),
          ],
          2
        ),
      ],
      64
    )
  )
}
export {
  w as SButton,
  C as SCheckbox,
  G as SDropdownButton,
  L as SFormField,
  U as SHeader,
  x as SIcon,
  M as SInput,
  D as SLabel,
  B as SLink,
  _ as SLogin,
  le as SNavbar,
  W as SPackageCard,
  ie as SRegistration,
  Q as SSearchbar,
  ce as SSidebar,
}
